import React, { memo } from "react"

import { Box, Text } from "@mos-cat/ds"
import { ActionsPopover, PersonIcon, SortDown, SortUp, Tooltip } from "@dit/core-frontend"

const SORT_OPTIONS = [
  {
    id: "custom",
    label: "Пользовательская",
    icon: <PersonIcon size="18" color="var(--gray-90)" />,
  },
  {
    id: "asc",
    label: "От А до Я",
    icon: <SortUp size="18" color="var(--gray-90)" />,
  },
  {
    id: "desc",
    label: "От Я до А",
    icon: <SortDown size="18" color="var(--gray-90)" />,
  },
]

export const SortControl = memo(({ sortPages, setSortPages }) => {
  const selectedOption = SORT_OPTIONS.find((option) => option.id === sortPages) || SORT_OPTIONS[0]

  return (
    <>
      <ActionsPopover
        customHoverStyle={{ backgroundColor: "" }}
        hoverColor=""
        customBackground="none"
        justifyContent="start"
        width="100%"
        borderBottom="1px solid var(--gray-20)"
        content={
          <Tooltip content={`Сортировка: ${selectedOption.label}`}>
            <Box display="flex" alignItems="center" gridGap="4px">
              {selectedOption.icon} <Text fontSize="14px">{selectedOption.label}</Text>
            </Box>
          </Tooltip>
        }
      >
        {(b, hidePopover) => (
          <>
            {SORT_OPTIONS.map((option) => (
              <Box
                display="flex"
                alignItems="center"
                gridGap="8px"
                key={option.id}
                onClick={() => {
                  setSortPages(option.id)
                  hidePopover()
                }}
                styles={{ cursor: "pointer", "&:hover": { color: "blue-60" } }}
              >
                {option.icon}
                <Text fontSize="14px">{option.label}</Text>
              </Box>
            ))}
          </>
        )}
      </ActionsPopover>
    </>
  )
})

SortControl.displayName = "SortControl"
